export default {
  notifications : []
}
